import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Steps, { Step } from 'rc-steps';
import './NavBar.scss';

const navSteps = [
  { title: 'Start', value: 'start' },
  { title: 'Description', value: 'description' },
  { title: 'Qualifications', value: 'qualifications' },
  { title: 'Budget & Logistics', value: 'budget & logistics' },
  { title: 'Preview', value: 'review' },
];

const sectionIndexMap = {
  start: 0,
  description: 1,
  'expertise-priority': 2,
  qualifications: 2,
  logistics: 3,
  budget: 3,
  'budget & logistics': 3,
  review: 4,
};

function NavBar({
  activeSection, handleUpdateSection, projectResourceId, validatedStep,
}) {
  const activeIndex = useMemo(() => sectionIndexMap[activeSection.trim()] || 0, [activeSection.trim()]);
  return (
    <div className="project-nav-bar-container">
      {/* Desktop View */}
      <div className="d-none d-md-block px-4">
        <Steps labelPlacement="vertical" current={activeIndex}>
          {navSteps.map((step, index) => (
            <Step
              key={index}
              title={step.title}
              {...(projectResourceId && { onStepClick: handleUpdateSection(step.value) })}
            />
          ))}
        </Steps>
      </div>

      {/* Mobile View */}
      <div className="d-sm-block d-md-none ps-4">
        <Steps labelPlacement="vertical" direction="vertical" current={activeIndex}>
          {navSteps.map((step, index) => (
            <Step
              key={index}
              title={step.title}
              {...(projectResourceId && { onStepClick: handleUpdateSection(step.value) })}
            />
          ))}
        </Steps>
      </div>
    </div>
  );
}

NavBar.propTypes = {
  activeSection: PropTypes.string.isRequired,
  handleUpdateSection: PropTypes.func.isRequired,
};

export default NavBar;
